// Keyed by id, not index, so a step can be named in a guard without counting the ones before it.
export type EgsWizardStep = 'ratePlan' | 'surcharges' | 'review';

export const EGS_WIZARD_STEPS: Array<EgsWizardStep> = ['ratePlan', 'surcharges', 'review'];

export const EGS_STEP_LABEL: Record<EgsWizardStep, string> = {
  ratePlan: 'Select rate plan',
  review: 'Review and apply',
  surcharges: 'Select surcharges',
};

/**
 * No entry for `review`: that step leads with an alert naming how many room rates Apply will write, and every
 * caveat a heading used to carry is now said on the room rate it applies to.
 */
export const EGS_STEP_HEADING: Partial<Record<EgsWizardStep, string>> = {
  ratePlan: 'Pick the rate plan to write to. Everything after this step covers only that plan.',
  surcharges: 'Every Salesforce surcharge on this rate plan. Check the rooms each one applies to.',
};

/**
 * Leaving one surcharge ticked to nothing is a valid answer: it says that surcharge is not for this offer.
 * Leaving every one of them ticked to nothing is not, because it reaches the review with nothing to show.
 */
export function getEgsStepBlockReason({
  ratePlanId,
  selectedRoomRateCount,
  step,
}: {
  ratePlanId: string | undefined;
  selectedRoomRateCount: number;
  step: EgsWizardStep;
}): string | undefined {
  if (step === 'ratePlan' && !ratePlanId) {
    return 'Pick the rate plan you want to write to.';
  }

  if (step === 'surcharges' && selectedRoomRateCount === 0) {
    return 'Tick the rooms on at least one surcharge.';
  }

  return undefined;
}
